<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ failed }"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="fieldGenericRules"
      :data-unit-test="`${stepId}_${questionId}`"
    >
      <radio
        v-model="fieldGenericModel"
        :name="`${stepId}_${questionId}`"
        :items="fieldGenericItems"
        :error="failed"
        column
        return-object
        :data-test="snakeCase(questionFields.field)"
      />
    </validation-provider>
    <template #subsection>
      <form-row
        gap="16"
      >
        <validation-provider
          v-slot="{ failedRules, errors }"
          :vid="`${stepId}_${questionId}-search`"
          :name="questionId"
          :rules="fieldGenericRules"
        >
          <qz-autocomplete
            v-model="searchModel"
            :data-test="`${stepId}_${questionId}-search`"
            :placeholder="helpers.getPlaceholderResponsiveText(searchPlaceholder, isMobile)"
            :items="searchItems"
            :errors="getFieldErrors('field', failedRules, errors)"
          />
        </validation-provider>
      </form-row>
    </template>
  </question-base-wrapper>
</template>

<script>
import BaseRadioList from '@/components/questions/BaseRadioList';

export default {
  name: 'question-base-radio-list-search',
  extends: BaseRadioList,
  props: {
    responseModel: {
      type: Object,
      default: () => ({
        value: 'value',
        name: 'name',
      }),
    },
    searchType: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      searchItems: [],
    };
  },
  computed: {
    searchModel: {
      get () {
        return this.questionData[this.questionFields.field];
      },
      set (value) {
        // To keep consistency with live products used 'text' of item as property value
        this.questionData[this.questionFields.field] = this.optionsConfig.isTextAsValue ? value?.text : value?.value;
      },
    },
    searchPlaceholder () {
      return this.optionsConfig?.placeholder;
    },
  },
  async created () {
    await this.onSearch('???');
  },
  methods: {
    async onSearch (value) {
      try {
        if (value === null) return;

        const response = await this.$api[this.searchType]({ ...this.searchPayload, query: value });

        if (response.status === 'success') {
          const { value, name } = this.responseModel;

          this.searchItems = response.data.map(item => ({
            value: +item[value] || item[value],
            text: item[name],
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
